<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false">

            <Form ref="formValidate" :model="params" :rules="ruleValidate" label-position="top">
                <FormItem label="商品名称：" prop="goodsName">
                    <Input v-model.trim="params.goodsName" placeholder="请输入商品名称"></Input>
                </FormItem>
                <FormItem label="商品图片：" prop="goodsImages">
                    <div class="j-img-echo">
                        <template v-if="!params.goodsImages">
                            <Icon type="md-images" size="55" color="#c5c8ce" />
                        </template>
                        <template v-else>
                            <img :src="params.goodsImages">
                        </template>
                    </div>
                    <Input v-model="params.goodsImages" disabled>
                        <div slot="prepend">
                            <Upload :action="action" :headers="headers" :show-upload-list="false" name="file"
                                    :on-success="uploadFirstSuccess">
                                <Button icon="ios-cloud-upload-outline">上传图片</Button>
                            </Upload>
                        </div>
                    </Input>
                    <Alert show-icon closable style="margin-top:10px">建议上传600x600像素的图片，大小不超过500kb</Alert>
                </FormItem>
                <FormItem label="积分兑换：" prop="integral">
                    <Input v-model.trim="params.integral" placeholder="请输入商品积分兑换个数" type="number"></Input>
                </FormItem>
            </Form>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="handleSubmit('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
    import hsEdit from '@/components/hs-edit';
    import goodsSkuOpe from './goods-sku-ope';

    export default {
        data() {
            return {
                isShowModal: false,
                loadingBtn: false,
                title: '查看信息',
                type: 0,
                action: this.$uploadURL,
                headers: {
                    token: JSON.parse(sessionStorage.getItem('J-TOKEN')).token
                },
                params: {
                    goodsId: '',
                    goodsName: '',
                    goodsImages: '',
                    integral: ''
                },
                ruleValidate: {
                    goodsName: [
                        {required: true, message: '商品名称不能为空', trigger: 'change'}
                    ],
                    goodsImages: [
                        {required: true, message: '商品图片不能为空', trigger: 'change'}
                    ],
                    integral: [
                        {required: true, message: '积分兑换不能为空', trigger: 'change'}
                    ]
                }
            }
        },
        methods: {
            // 点击提交验证
            handleSubmit(name) {
                // console.log(this.params);

                this.$refs[name].validate((valid) => {
                    if (valid) {
                        // this.$Message.error('验证通过');
                        /**
                         * type判断
                         * 1.查看 2.新增 3.编辑
                         */
                        switch (this.type) {
                            case 1:
                                // this.title = '查看商品';
                                break;
                            case 2:
                                // 新增商品
                                this.addGoods();
                                break;
                            case 3:
                                // 编辑商品
                                this.updateGoods();
                                break;
                            default:
                                this.$Notice.error({
                                    title: '商品管理',
                                    desc: '查看，新增，编辑区分判断报错',
                                    duration: 0
                                });
                                break
                        }
                    } else {
                        this.$Message.error('还有信息没有填写合格哦~');
                    }
                })
            },
            // 显示模态框
            show(type, row) {
                this.isShowModal = true;
                this.type = type;
                /**
                 * type判断
                 * 1.查看 2.新增 3.编辑
                 */
                switch (type) {
                    case 1:
                        this.title = '查看商品';
                        this.findInfo(row);
                        break;
                    case 2:
                        this.title = '新增商品';
                        break;
                    case 3:
                        this.title = '编辑商品';
                        this.findInfo(row);
                        break;
                    default:
                        this.$Notice.error({
                            title: '商品管理',
                            desc: '查看，新增，编辑模态框报错',
                            duration: 0
                        });
                        break
                }
            },
            // 新增商品
            addGoods() {
                this.$Spin.show();
                this.axios.post('/convertibleGoods/addConvertibleGoods', this.params).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if (res.status == 201) {
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '新增商品接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 编辑商品
            updateGoods() {
                this.$Spin.show();
                this.axios.post('/convertibleGoods/updateConvertibleGoods', this.params).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        this.$emit('changeDate');
                        this.$Message.success('操作成功.');
                        this.hide('formValidate');
                    }
                    if (res.status == 201) {
                        this.$Message.error(res.msg);
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '编辑商品接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 查询商品详情
            findInfo(row) {
                this.$Spin.show();
                this.axios.post('/convertibleGoods/getInfo', {
                    goodsId: row.goodsId
                }).then(res => {
                    console.log(res);
                    setTimeout(() => {
                        this.$Spin.hide();
                    }, 300);
                    if (res.status == 200) {
                        // this.$Message.success('操作成功.');
                        this.params.goodsId = res.data.goodsId;
                        this.params.goodsName = res.data.goodsName;
                        this.params.goodsImages = res.data.goodsImages;
                        this.params.integral = res.data.integral.toString();
                    }
                    if (res.status == 500) {
                        this.$Notice.error({
                            title: '服务器内部错误',
                            desc: '查看商品详情接口报错',
                            duration: 0
                        });
                    }
                })
            },
            // 商品首图上传成功
            uploadFirstSuccess(response, file, fileList) {
                if (response.status == 200) {
                    this.params.goodsImages = response.data;
                }
                if (response.status == 201) {
                    this.$Message.error(response.msg);
                }
                if (response.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '上传图片首图接口报错',
                        duration: 0
                    });
                }
            },
            // 关闭模态框
            hide(name) {
                this.isShowModal = false
                this.$refs[name].resetFields();
            }
        },
        components: {
            hsEdit,
            goodsSkuOpe
        }
    }
</script>

<style scoped lang="less">
    .hs-upload-image-box {
        display: flex;
        align-items: center;
        position: relative;

        .hs-upload-image {
            width: 145px;
            height: 145px;
            margin-top: -8px;
            margin-left: 10px;
            border: 1px solid #efefef;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .hs-upload-image-delete {
                position: absolute;
                top: -8px;
                right: -8px;
                width: 20px;
                height: 20px;
                background-color: red;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                border-radius: 50%;
            }

            .hs-upload-image-setting {
                position: absolute;
                bottom: 0;
                width: 100%;
                color: #ffffff;
                height: 40px;
                display: none;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0, .8);
            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        .hs-upload-add {
            cursor: pointer;
            width: 145px;
            height: 145px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px dashed #cccccc;
            transition: all .3s;

            &:hover {
                color: #2d8cf0;
                border: 1px dashed #2d8cf0;
            }
        }
    }
</style>